module.exports = __webpack_public_path__ + "img/5.d0a2ca15.png";